/**
 * Checks if the given value is a string primitive.
 */
export const isString = (value: unknown) => typeof value === "string"
